export default __webpack_public_path__ + "static/media/customizeProduct.712cc3fd.svg";